export const CHECK_SCREENING_MX = "CHECK_SCREENING_MX"
export const CHECK_SCREENING_MX_SUCCESS = "CHECK_SCREENING_MX_SUCCESS"

export const RESET_SCREENING_MAMMOGRAFICO_STATE = "RESET_SCREENING_MAMMOGRAFICO_STATE"